export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  EMAIL_VERIFIED: '/email-verified',
  PERSONAL_INFO: '/personal-info',
  BANK_INFORMATION: '/bank-information',

  MY_MUSIC: '/my-music',
  UPLOAD_MUSIC: '/upload-music',
  REPORTS: '/reports',
  FINANCIAL: '/financial',
  TnC: '/terms-and-conditions',
  PROFILE: '/profile',
  CONTACT_US: '/contact-us',
  RESET_PASSWORD: '/reset-password',
  FORGOT_PASSWORD: '/forgot-password',
};
